import { createFileRoute } from '@tanstack/react-router';
import Journal from 'src/pages/Organization/Event/Checkout/Journal';

export const Route = createFileRoute(
  '/$organizationSlug/players/$playerId/characters/$characterId/journal',
)({
  component: Journal,
});
